moduleMap = angular.module('map.initializer', [])

moduleMap.service 'MapInit', ["$timeout", "$injector", "ns", ($timeout, $injector, ns) ->
  'use strict'
  Y = undefined

  mapinit =
    init: (y) ->
      Y = y
      @initMaps()
    resizers: []
    findMaps: ->
      layoutEditor = $injector.get "layoutEditor"
      @maps = $(".strw__map")
    initGoogleMap: (options) ->
      myLatLng = {lat: options.lat, lng: options.lon}
      geocoder = new google.maps.Geocoder()
      map = new google.maps.Map document.getElementById('str-map-'+options.id),
        center: myLatLng,
        scrollwheel: false,
        zoom: options.zoom,
        streetViewControl: false,
        mapTypeControl: false
      marker = new google.maps.Marker
        position: myLatLng,
        map: map,
        draggable:true
      # set popover html
      infowindow = new google.maps.InfoWindow
        content: options.pin_text
      marker.addListener 'click', ->
        infowindow.open map, marker
      map.setCenter myLatLng
      map.setZoom options.zoom
      marker.setPosition myLatLng
      {
        map_instance: map
        geocoder: geocoder
        marker: marker
        infowindow: infowindow
      }
    initYandexMap: (options) ->
      myLatLng = [options.lat, options.lon]
      map = new ymaps.Map 'str-map-'+options.id,
        center: myLatLng,
        zoom: options.zoom
      removeList = [
        'typeSelector',
        'searchControl',
        'rulerControl',
        'fullscreenControl',
        'trafficControl',
        'geolocationControl'
      ]
      _.each removeList, (removeItem) ->
        map.controls.remove removeItem
      marker = new ymaps.Placemark myLatLng,
        balloonContent: options.pin_text
      ,
        draggable: true
      map.setZoom options.zoom
      map.geoObjects.add marker

      {
        map_instance: map
        marker: marker
      }
    initMap: (index, mapEl, options_a = false) ->
      if !options_a
        options = $(mapEl).data "map-options"
      else
        options = options_a
      el = $(mapEl).parents(ns.blockClass)[0]
      if options.provider is "google"
        el.googleMap = mapinit.initGoogleMap options
      if options.provider is "yandex"
        el.yandexMap = mapinit.initYandexMap options
      el["#{options.provider}Map"]
    initMaps: ->
      @findMaps()
      @maps.each @initMap
    destroy: ->
      return
  mapinit

]



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/map/map.initializer.coffee